import React from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { MarkCompleteCrossIcon } from "../common/Icon";
import { useStateProvider } from "../common/StateProvider";
import AttachFileModal from "../common/AttachFileModal";
const MarkCompletedModal = ({
  markModal,
  setmarkModal,
  markCompleteModalHeading,
}) => {
  const { attachFileModal, setAttachFileModal } = useStateProvider(); //ATTACH FILE MODAL
  // // Function to show the Attach File MODAL
  // const openAttachFileModal = () => {
  //   setAttachFileModal(true);
  // };

  // Function to close the Attach File MODAL
  const closeAttachFileModal = () => {
    setAttachFileModal(false);
  };
  return (
    <>
      <Transition appear show={markModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[99999999]"
          onClose={() => {
            setmarkModal();
          }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-[#0d10143d]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className=" transition-all">
                  <div className="w-full max-w-[320px] xm:max-w-[500px]  md:max-w-[800px] bg-white pt-6 pb-[14px] px-[18px] z-10 relative rounded-xl mx-auto text-white">
                    <div className=" flex items-center justify-between mb-4">
                      <h3 className="text-xs 3xl:text-base text-black font-semibold ">
                        {markCompleteModalHeading}
                      </h3>
                      <button
                        onClick={() => {
                          setmarkModal(false);
                        }}>
                        <MarkCompleteCrossIcon />
                      </button>
                    </div>
                    <textarea
                      className="text-xs 3xl:text-[16px] w-full font-normal text-black placeholder:text-black placeholder:opacity-[0.21] 3xl:placeholder:opacity-60 py-4 px-4 3xl:px-3 rounded-xl border border-solid border-[rgba(0,_0,_0,_0.20)] outline-primary resize-none"
                      name=""
                      cols="80"
                      rows="5"
                      placeholder="Add notes"></textarea>
                    <div className="pt-5">
                      <button
                        onClick={() => {
                          setAttachFileModal(true);
                        }}
                        className="text-[10px] 3xl:text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary p-[4px_10px] hover:bg-primary hover:text-white hover:border-transparent duration-200">
                        + Attach File
                      </button>
                    </div>
                    <div className="pt-5 flex justify-end">
                      <button
                        onClick={() => {
                          setmarkModal(false);
                        }}
                        className="text-sm font-semibold text-white rounded-[37px] bg-primary p-[8px_26px] hover:text-black hover:bg-[#d3d2ee] duration-200">
                        Save
                      </button>
                    </div>
                    {/* Attach File MODAL */}
                    <div className="absolute top-[-40px] z-50  left-0 xm:left-[20px]  md:left-[70px] ">
                      {attachFileModal && (
                        <AttachFileModal
                          setAttachFileModal={closeAttachFileModal}
                          attachFileModal={attachFileModal}
                        />
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default MarkCompletedModal;
